module.exports = __webpack_public_path__ + "img/9f5062d.jpg";